import { create } from "zustand";
import { API_BASE_URL1 } from "../Components/Services/baseApiUrl";
import axiosInstance from "../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const getMasterAPIStore = create((set, get) => ({
  zoneData: [],
  zoneLoading: false,
  zoneError: false,

  circleData: [],
  circleLoading: false,
  circleError: false,

  wardData: [],
  wardLoading: false,
  wardError: false,

  shiftData: [],
  shiftLoading: false,
  shiftError: false,

  ownerTypeData: [],
  ownerTypeLoading: false,
  ownerTypeError: false,

  fetchZoneData: async () => {
    set({ zoneLoading: true, zoneError: null });
    try {
      const response = await axiosInstance.get(API_BASE_URL1+`MasterDetails/GetAllZone`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      set({ zoneData: response.data, zoneError: false });
    } catch (error) {
      set({ zoneError: error.message });
    } finally {
      set({ zoneLoading: false });
    }
  },

  fetchCircleData: async () => {
    set({ circleLoading: true, circleError: null });
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllCircles`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      set({ circleData: response.data, circleError: false });
    } catch (error) {
      set({ circleError: error.message });
    } finally {
      set({ circleLoading: false });
    }
  },  

  fetchWardData: async () => {
    set({ wardLoading: true, wardError: null });
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllWard`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      set({ wardData: response.data, wardError: false });
    } catch (error) {
      set({ wardError: error.message });
    } finally {
      set({ wardLoading: false });
    }
  },

  fetchShiftData: async () => {
    set({ shiftLoading: true, shiftError: null });
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllShifts`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });
      set({ shiftData: response.data, shiftError: false });
    } catch (error) {
      set({ shiftError: error.message });
    } finally {
      set({ shiftLoading: false });
    }
  },

  fetchOwnerTypeData: async () => {
    set({ ownerTypeLoading: true, ownerTypeError: null });
    try {
      const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllOwnerTypes`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });
      set({ ownerTypeData: response.data, ownerTypeError: false });
    } catch (error) {
      set({ ownerTypeError: error.message });
    } finally {
      set({ ownerTypeLoading: false });
    }
  },


}));